import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const cn={
    common: {
        logout_success: '登出成功',
        operate_success: "操作成功",
        operate_fail: "操作失败",
        add_success: "添加成功",
        add_fail: "添加失败",
        save_success: "保存成功",
        system_warn: "系统提示",
        ok_text: "确定",
        cancel_text: "取消",
        confirm_continue_text: "你确定要继续吗?",
        confirm_delete_text: "你确定要删除吗?",
        cancel_operate_text: "已取消操作",
        open: "开",
        close: "关",
        add: "添加",
        edit: "修改",
        delete: "删除",
        save:"保存",
        cancel: "取 消",
        submit: "确 定",
        operation: "操作",
        index: "序号",
        pleaseInput: "请输入",
        pleaseSelect: "请选择",
        enable: "启用",
        disable: "禁用",
        show: "显示",
        hide: "隐藏",
    },
    message:{
        menu:{
            title:"Stage Now 2.0",
            systemSettings:'基础设置',
            featuredSettings:"特色设置",
            scanningTool:'扫描工具',
            mobileButler:'移动管家',
            hotKeys:"热键设置",
            digitalCertificate:"数字证书",
            OtherSettings:"其他设置",
            help:"帮助",
            appDesktop:"应用及桌面",
            Selected:"已选择",
            items:"项",
            QRCode:"二维码",
            Personalization:"个性化配置"
        },
        button:{
            previewXml:"预览xml",
            exportXml:"导出xml",
            previewQRCode:"预览二维码",
            downloadQRCode:"下载二维码",
            resetAll:"重置输入",
            instructions:"使用说明",
            downLoadAll:'下载全部二维码'
        },
        info:{
            QrCodeInfo:"暂未配置任何参数/勾选菜单，请先配置/勾选",
            downLoadInfo:"暂未生成二维码，请先配置参数",
            pwdInfo:"密码至少8位"
        },
        // 特色配置
        featrueSettingMsg:{
            deleteConfiguration:"删除配置",
            otherConfigurations:"其他配置",
            clearConfiguration:"清空配置",
            FnkeyStickingPrimaryMode:"Fn键粘滞一次模式",
            shieldingP5FunctionKey:"屏蔽P5功能按键",
            shieldingP7FunctionKey:"屏蔽P7功能按键",
            touchScreenGloveMode:"触摸屏手套模式",
            disableStatusBarDropdown:"禁止状态栏下拉",
            hideSoftKeyboard:"隐藏软键盘",
            shieldVirtualKey1:"屏蔽虚拟键1",
            shieldVirtualKey2:"屏蔽虚拟键2",
            shieldVirtualKey3:"屏蔽虚拟键3",
            recentToMenu:'RECENT转换为MENU',
            shieldedHardKeyboardHOMEKey:"屏蔽硬键盘HOME键",
            shieldLockScreenKey:"屏蔽锁屏键",
            prohibitedAppKey:"禁止将扫描按键的键值传递给应用",
            automaticallyRestart:"重启后自动取消所有APP的未知来源安装权限",
            hardKeyboardPromptTone:"硬键盘提示音",
            displayScanHoverButton:"显示扫描悬浮按钮",
            getDeviceId:"getDeviceId()接口强制返回IMEI",
            installUnknown:"允许文件app安装未知来源应用",
            noDropDetection:"禁止跌落检测",
            fixedChargingMode:"固定充电模式",
            installAppUnknown:"允许所有应用安装未知来源应用",
            noPwdEnter:"进入开发者选项不需要输入密码",
            wakeUpScanKey:"扫描键唤醒扫描",
            wakeUpScreen:"扫描键唤醒亮屏",
            wakeUpDevice:"抬起唤醒设备",
            voiceKeyEnable:"语音键使能",
            customizeFunctionKeySettings:{
                title:"自定义功能键设置",
                nothing:"无",
                flashlight:"手电筒",
                pupilLamp:"瞳孔灯"
            },
            USBChargingOnly:"USB仅限充电",
            supportRotation:"支持屏幕倒置旋转显示",
            applyCompatibilityMode:"应用兼容模式",
            focusModeEnhancement:"焦点录入模式增强",
            DoubleClickWakeUpScreen:"双击唤醒屏幕"
          
        },
        // 移动管家
        mobileButlerMsg:{
            deleteConfiguration: "删除配置",
            desktopAppList: "桌面应用列表",
            autoStartApp: "自启动应用",
            basicSettings: "基本设置",

            clearAllConfig: "清空所有配置",
            clearAppConfig: "清空应用配置",
            addApp: "新增应用",
            showOnDesktop: "在桌面展示",
            accountInfo: "账号信息",
            username: "用户名",
            password: "密码",
            screenSaverSettings: "屏保信息",
            question: "问题",
            answer: "答案",
            answerEncryptionType: "答案加密类型",
            other: "其他",
            allowNewAppAdd: "允许新应用默认添加",
            bootStartup: "移动管家开机自启动",
        },
        // 数字证书
        digitalCertificateMsg:{
            deleteConfiguration:"删除配置",
            clearConfiguration:"清空配置",
            deleteSignature:"删除签名",
            dataType:"数据类型",
            deleteByCertificateName:"根据证书名称删除",
            deleteByCertificateContent:"根据证书内容删除",
            certificateNameOrCertificateContent:"证书名称或证书内容",
            certificate:"证书",
            certificateName:"证书名称",
            certificateContent:"证书内容"
        },
        // 热键设置
        hotKeysMsg:{
            deleteConfiguration:{
                title:"删除配置",
                clearAllConfigurations:"清空所有配置",
                clearAllMappings:"清空所有映射",
                clearAllBroadcasts:"清空所有广播",
                deletedesignatedBroadcast:"删除指定广播",
                deleteBroadcastName:"广播名称",
            },
            configureBroadcast:{
                title:"配置广播",
                addBroadcast:"添加广播",
                broadcastName:"广播名称",
                parameter:"参数",
                addParameter:"添加参数",
                name:"名称",
                type:"类型",
                value:"值",
            },
            keyValueMapping:{
                title:"键值映射",
                addKeyValue:"添加键值映射",
                enterPhysicalKey:"输入物理键",
                mappingType:"映射类型",
                androidKeyValue:"Android键值",
                broadcastName:"广播名称",
                appPackageName:"应用包名",
                appClassName:"应用类名(启动项)",
                mappingBroadcast:"BROADCAST(映射广播)",
                mappingApp:"APPLICATION(映射应用)",
                mappingOtherKey:"OTHER_KEYCODE(映射其他键)",
                noMapping:"NONE(不映射)",
            }
        },
        // 扫码工具条码设置
        scanningToolMsg:{
            deleteConfiguration:"删除配置",
            clearAllConfigurations:"清空所有配置",
            clearBarcodeConfiguration:"清空条码配置",
            clearApplicationConfiguration:"清空应用配置",
            barcodeSettings:"条码设置",
            basicSettings:{
                title:"基本设置",
                securityLevel:"安全级别(0-2)",
                lighting:"灯光",
                centeringAccuracyLevel:"准心精度级别(1-4)",
                negativeMode:"场景模式",
                lowPowerDelayTime:"低功耗延时时间(0-120)",
                Duration:"持续时间(UE966,SE965,EM1350[1-99],N4313[1-30000],其他[0,255])",
                scanAngle:"扫描角度(N4313[0-1], EM1350,SE965[0,1,2],其他[5,6])",
                timeOut:"超时时间(N4313[0-30000],其他[0-99])",
                securityLevel2:"安全级别(N6600,EX30[1-3],X3[0-2],其他[0-3])",
                twoWayScanning:"双向扫描",
                backgroundLightIntensity:"背景光强度",
                scanDuration:"扫描持续时间(SE4750,SE4500,SE4750DPM[5-30],SE4850[5-99])",
                adaptiveScanMode:"自适应扫描模式(可选值[0,1])",
                exposure:"曝光",
                centeringMode:"准心模式",
                GS1:"GS1应用标识分隔符",
                aimPrefix:"Aim前缀",
                inversionMode:"反色模式(EX30,N5600,N600,X3[0,1,2],其他[0,1])",
                aimerMode:"Aimer模式(SE4850[0,1,2,3],EX30[0,1,2],其他[0,1])",
                sensitivityLevel:"感光等级",
                scanTimeout:"扫描超时时间(1-10)",
                DPMMode:"DPM 模式",
                fillLightSwitch:"补光灯开关",
                standardScenarios:"标准场景",
                Scenario1:"场景1",
                Scenario2:"场景2",
                Scenario3:"场景3",
                multipleBarcodeReadingQuantity:"多条码读取数量(0-30)",
                multiBarcodeInstantReport:"多条码即时报告",
                multiBarcodeReadingDuration:"多条码读取时长(500-30000)",
                enhancedSoiledBarcode:"污损条码读取性能增强",
            },
            code128:{
                minimumBarcode:"条码最小长度(0-80)",
                maximumBarcode:"条码最大长度(0-80)",
                ISBT128:"ISBT 128 系列码(N4313可选值[0-2],其他[0,1])",
                quietZone:"静区",
                negativeMode:"反色模式",
                normalBarcode:"正常条码",
                nbrb:"正常条码和反色条码",
                decodingRateEnhancement:"解码率增强"
            },
            UPC:{
                transmitUPCA:"传输UPC-A 校验码",
                transmitUPCE:"传输UPC-E 校验码",
                transmitEAN13:"传输EAN13 校验码",
                transmitEAN8:"传输EAN8 校验码",
                UPCAPlusPrefix:"UPC-A 加前缀",
                doNotAdd:"不添加",
                addSystemCharactersOnly:"仅添加系统字符",
                addCountryNumber:"添加国家编号与系统字符",
                UPCEPlusPrefix:"UPC-E 加前缀",
                UPCE1PlusPrefix:"UPC-E1 加前缀",
                convertUPCEToUPCA:"将UPC-E 转换成 UPC-A",
                convertUPCE1ToUPCA:"将UPC-E1 转换成 UPC-A",
                Add5ZerosBeforeEAN8:"EAN-8前加5个0协调EAN-13",
                useUCCCoupon:"使用UCC Coupon Extended Code 模式",
                UPCEExtension:"UPCE扩展",
                UPCAAdditional2:"UPC-A附加码2位",
                UPCAAdditional5:"UPC-A附加码5位",
                UPCEAdditional2:"UPC-E附加码2位",
                UPCEAdditional5:"UPC-E附加码5位",
                EAN13Additional2:"EAN13附加码2位",
                EAN13Additional5:"EAN13附加码5位",
                EAN8Additional2:"EAN8附加码2位",
                EAN8Additional5:"EAN8附加码5位",
                quietZone:"静区",
                negativeMode:"反色模式",
                normalBarcode:"正常条码",
                nbrb:"正常条码和反色条码",
                decodingRateEnhancement:"解码率增强"
            },
            code39:{
                code39To32:"将Code 39 转成 Code 32",
                addABeforeCode32:"在Code 32前加A(N4313名称:Code 39 起始/终止符)",
                minimum:"条码最小长度(0-48)",
                maximum:"条码最大长度(0-48)",
                transmissionCheckCode:"传输校验码",
                checkCode:"检验校验码",
                code39Character:"Code 39 起始/终止符",
                quietZone:"静区",
                negativeMode:"反色模式",
                normalBarcode:"正常条码",
                nbrb:"正常条码和反色条码",
                decodingRateEnhancement:"解码率增强"
            },
            code93:{
                minimum:"条码最小长度(0-80)",
                maximum:"条码最大长度(0-80)",
                quietZone:"静区",
                negativeMode:"反色模式",
                normalBarcode:"正常条码",
                nbrb:"正常条码和反色条码",
            },
            code11:{
                minimum:"条码最小长度(1-80)",
                maximum:"条码最大长度(1-80)",
                checkCode:"检验校验码",
                transmissionCheckCode:"传输校验码",
                twoCheckBitsAndTransmit:"2个校验位且传输",
                oneCheckBitsAndTransmit:"1个校验位且传输",
                twoWithoutTransmit:"2个校验位且不传输",
                oneWithoutTransmit:"1个校验位且不传输",
                notcheck:"不检查校验位且全部传输"

            },
            Interleaved2Of5:{
                minimum:"条码最小长度(2-80)",
                maximum:"条码最大长度(2-80)",
                checkCode:"检验校验码",
                transmissionCheckCode:"传输校验码",
                staticZone:"静区",
                negativeMode:"反色模式",
                normalBarcode:"正常条码",
                nbrb:"正常条码和反色条码",
                null:"无",
                CheckNoTransmit:"校验不传输",
                CheckAndTransmit:"校验并传输",
                bfConvertToEAN13:"转换成EAN13",
            },
            Discrete2Of5:{
                minimum:"条码最小长度(2-60)",
                maximum:"条码最大长度(2-60)",
            },
            Codabar:{
                minimum:"条码最小长度(2-60)",
                maximum:"条码最大长度(2-60)",
                startStopBit:"Codabar 起始位/停止位",
                quietZone:"静区",
                negativeMode:"反色模式",
                normalBarcode:"正常条码",
                nbrb:"正常条码和反色条码",
            },
            NEC2Of5:{
                minimum:"条码最小长度(4-80)",
                maximum:"条码最大长度(4-80)"
            },
            MSI:{
                minimum:"条码最小长度(4-48)",
                maximum:"条码最大长度(4-48)"
            },
            RSS:{
                restriction:"RSS 限制",
                extension:"RSS 扩展",
                RSStoUPC:"RSS 转 UPC/EAN"
            },
            QR:{
                minimum:"条码最小长度(1-7089)",
                maximum:"条码最大长度(1-7089)",
                QRInverse:"QR Inverse(x3,d100[0,1],其他[0,1,2])",
                quietZone:"静区"
            },
            DataMatrix:{
                dataMatrix:"Data Matrix",
                minimum:"条码最小长度(1-3166)",
                maximum:"条码最大长度(1-3166)",
                dataMatrixInverse:"Data Matrix Inverse(x3,d100[0,1],其他[0,1,2])",
                never:"从不",
                always:"总是",
                auto:"自动",
                negativeMode:"反色模式",
                normalBarcode:"正常条码",
                inverseBarcode:"反色条码",
                nbrb:"正常条码和反色条码",
            },
            ChinaPost:{
                minimum:"条码最小长度(4-80)",
                maximum:"条码最大长度(4-80)"
            },
            Matrix2Of5:{
                Matrix2Of5minimum:"条码最小长度(4-80)",
                Matrix2Of5maximum:"条码最大长度(4-80)"
            },
            EANUCCComposite:{
                EANminimum:"条码最小长度(1-300)",
                EANmaximum:"条码最大长度(1-300)"
            },
            Composite:{
                hybrid:"UPC/EAN 混合条码"
            },
            PDF417:{
                PDF417minimum:"条码最小长度(1-2750)",
                PDF417maximum:"条码最大长度(1-2750)",
                negativeMode:"反色模式",
                normalBarcode:"正常条码",
                nbrb:"正常条码和反色条码",
                decodingRateEnhancement:"解码率增强"
            },
            MicroPDF417:{
                MicroPDF417minimum:"条码最小长度(1-2750)",
                MicroPDF417maximum:"条码最大长度(1-2750)"
            },
            MaxiCode:{
                MaxiCodeminimum:"条码最小长度(1-150)",
                MaxiCodemaximum:"条码最大长度(1-150)"
            },
            Aztec:{
                Aztecminimum:"条码最小长度(1-3832)",
                Aztecmaximum:"条码最大长度(1-3832)",
                routine:"常规",
                reverse:"反向",
                automaticDetection:"自动检测"
            },
            CodablockF:{
                CodablockFminimum:"条码最小长度(0-2048)",
                CodablockFmaximum:"条码最大长度(0-2048)"
            },
            Telepen:{
                Telepenminimum:"条码最小长度(1-60)",
                Telepenmaximum:"条码最大长度(1-60)"
            },
            OCR:{
                OCRValue:"用户模板OCR值",
                templateSelection:"模板选择"
            }
        },
        // 扫码工具应用设置
        applySettings:{
            title:"应用设置",
            generalTitle:"一般设置",
            AutoEmptying:"自动清空",
            startUpAuto:"开机自启动",
            displayBarcodeType:"显示条码类型",
            filterInvisibleCharacters:"过滤不可见字符",
            convertInvisibleCharacters:"转换不可见字符",
            characterSubstitutionSettings:"字符替换设置",
            setUp:"设置",
            filterBarcode:"过滤条码首尾空格",
            scanSound:"扫描声音",
            scanningLight:"扫描提示灯",
            Vibration:"振动",
            barcodeAddition:"条码追加",
            stopScann:"抬起停止扫描",
            enableScanningStatistics:"开启扫描统计",
            circularScanning:"循环扫描",
            intervalTime:"间隔时间(毫秒)",
            cycleScanInterval:"循环扫描间隔",
            MultiBarcode:"多条码",
            MultiBarcodeDisplay:"多条码计数显示",
            barcodeSuffix:"条码后缀",
            barcodePrefix:"条码前缀",
            Terminator:"结束符",
            characterSet:"字符集",
            triggerMode:"触发模式",
            ssrhs:"单次扫描(抬手停止)",
            singleScan:"单次扫描",
            sshs:"单次扫描(抬手扫描)",
            ssdps:'单次扫描(两次按下扫描)',
            cspas:"循环扫描(再次按下停止)",
            continuousLighting:"持续出光",
            clhls:"持续出光(抬手停止)",
            MultiBarcodeScanning:"多条码扫描",
            mbsrhr:'多条码扫描(抬手上报)',
            sendingMethod:"发送方式",
            FocusEntry:"焦点录入",
            broadcast:"广播",
            AnalogKey:"模拟按键",
            clipboard:"剪贴板",
            terminatorCase:"结束符以按键方式发送",
            AutoSubmit:"自动提交",
            BroadcastName:"广播名称",
            KeyValueName:"键值名称",
            startScanningBroadcast:"开始扫描广播",
            stopScanningBroadcast:"停止扫描广播",
            addReturnEvent:"默认广播时添加回车事件",
            scanKeyShielding:"扫描键屏蔽",
            userPassword:"用户密码(MD5加密后)",
            usageMode:"使用模式",
            standardMode:"标准模式",
            visitorMode:"访客模式",
            NormalMode:'循环扫描间隔',
            EnhancedMode:"扫描无数据时的间隔时间",
            EnhancedModeData:"扫描有数据时的间隔时间",
            mode:"模式",
            NormalMode1:'普通模式',
            EnhancedMode1:"增强模式",
            Cancel:"取消",
            Submit:"确定",
            CharacterSubstitution:"字符替换",
            SourceCharacter:"源字符",
            ReplaceCharacter:"替换字符",
            add:"添加",
            BarcodeSplicing:"条码拼接",
            open:"开",
            close:"关",
            index:"序号",
            operation:"操作",
            Separator:"分隔符",
            Code128:"Code 128条码拼接",
            BarcodeSuspensionSetting:"条码悬浮设置",
            BarcodeSending:"条码发送",
            DeveloperItem:"开发者项",
            Other:"其他",
            terminatorKey:"结束符以按键方式发送",
            autoSubmit:"自动提交",
            BroadcastCustomization:"广播定制",
            StartScanBroadcast:"开始扫描广播",
            StopScanBroadcast:"停止扫描广播",
            carriageReturnTime:"默认广播时条码后添加回车事件",
            ScanKeyShield:"扫描键屏蔽",
            ScanKeyMask:"扫描键屏蔽(多个使用逗号分隔)",
            SetUniversalPassword:"设置通用密码",
            GeneralPassword:"通用密码",
            BarcodeTruncation:"条码截断设置",
            StartIndex:"开始位置",
            EndIndex:"结束位置",
            StartCharacter:"开始字符",
            EndCharacter:"结束字符",
            CharacterMode:"字符模式",
            IndexMode:"位置模式",
            NoSeparator:"无分隔符",
            Space:"空格",
            LineBreak:"换行符"
        },
        // 基本设置
        systemMsg:{
            displaySettings:"显示设置",
            AutoBrightness:"自动亮度",
            BrightnessPercentage:"亮度百分比",
            SleepTime:"休眠时间",
            fifs:"15秒",
            thirtys:"30秒",
            onemin:"1分钟",
            secmin:"2分钟",
            fifmin:"5分钟",
            tenmin:"10分钟",
            thirtymin:"30分钟",
            NeverSleep:"永不休眠",
            MediaVolume:"媒体音量",
            soundSettings:"声音设置",
            ringerVolume:"铃声音量",
            AlarmVolume:"闹钟音量",
            WiFiSettings:"Wi-Fi设置",
            WifiManagement:"Wi-Fi管理",
            WiFiSwitch:"Wi-Fi开关",
            switchSelect:{
                null:"空",
                open:"开",
                close:'关',
                small:"小",
                large:"大",
                default:"默认",
                maximum:"最大",
                '001':'12小时',
                '002':'24小时'
            },
            NewWifiList:"新增Wi-Fi列表",
            WifiInformation:"Wi-Fi信息",
            selectSecurity:"请选择安全性",
            password:"密码",
            add:"添加",
            powerSavingMode:"省电模式",
            powerSaving:"省电",
            fullPower:"全功",
            fullAttack:"全功但睡眠时采取省电策略",
            bandSelect:"频带选择",
            auto:"自动",
            fifhz:"仅限5Hz频带",
            twohz:"仅限2.4Hz频带",
            wifiSSID:"Wi-Fi SSID过滤规则",
            doNotRules:"不采取任何过滤规则",
            onlyWhite:"只显示白名单的AP",
            onlyBlack:"不显示黑名单的AP",
            RoamingThreshold:"Wi-Fi漫游阈值",
            RoamingIncrement:"Wi-Fi漫游增量",
            WhiteList:"白名单",
            blacklist:"黑名单",
            MobileNetworkSettings:"移动网络设置",
            MobileNetworkSwitch:"移动网络开关",
            ApnName:"名称",
            agent:"代理",
            port:"端口",
            userName:"用户名",
            OtherSettings:"其他设置",
            RemoveAllWifi:"移除所有Wi-Fi",
            Bluetooth:"蓝牙",
            camera:"相机",
            autoTimeZone:"自动确定时区",
            autoDate:"自动确定日期和时间",
            fontSize:"字体大小",
            DisplaySize:"显示大小",
            EncryptionType:"加密类型",
            AddWifi:"添加Wi-Fi",
            EPA:"EPA方法",
            Authentication:"身份验证",
            CA:"CA证书",
            sysCertificate:"使用系统证书",
            NotVerify:"不验证",
            domainName:"域名",
            identity:"身份",
            AnonymousIdentity:"匿名身份",
            HiddenNetwork:'隐藏的网络',
            true:"是",
            false:"否",
            Cancel:"取消",
            Submit:"确定",
            save:"保存",
            index:"序号",
            operation:"操作",
            addWhitelist:"添加Wi-Fi白名单",
            addBlacklist:"添加Wi-Fi黑名单",
            UseDeviceMac:"MAC地址",
            trueUseDeviceMac:"使用设备mac",
            falseUseDeviceMac:"使用随机mac",
            Navabar:"导航栏",
        },
        // 其他设置
        otherSettingsMsg:{
            USBExternalStorage:"USB外部存储",
            PCUSB:"PC通过USB访问设备存储"
        },
        // 应用及桌面
        appDesktopMsg:{
            BlacklistApp:"黑名单应用",
            addBlacklistApp:"新增黑名单应用",
            BlacklistInfo:"黑名单信息",
            appName:"应用名称",
            PackageName:"包名",
            uninstallApp:"不可卸载应用",
            addUninstallApp:"新增不可卸载应用",
            uninstallAppInfo:"不可卸载应用信息",
            LiveApp:"保活应用",
            addLiveApp:"新增保活应用",
            LiveAppInfo:"保活应用信息",
            desktopType:"自定义桌面类型",
            addDesktopType:"新增桌面类型",
            desktopInfo:"桌面类型信息",
            add:"添加",
            Cancel:"取消",
            Submit:"确定",
            save:"保存",
            index:"序号",
            operation:"操作",
            addWhitelist:"添加Wi-Fi白名单",
            addBlacklist:"添加Wi-Fi黑名单",
        },
        // 提示信息
        messageMsg:{
            minLagermax:"最小长度不能大于最大长度",
            strNoEmpty:"源字符不能为空",
            InputSSID:"请输入ssid",
            InputSecurity:"请选择安全性",
            ssidNoEmpty:"ssid不能为空",
            save:"请先保存",
            pnNoEmpty:"包名不能为空",
            normalModeTime:"请输入普通模式时间间隔",
            enhancedMode:"请输入增强模式无数据时间间隔",
            enhancedData:"请输入增强模式有数据时间间隔",
            selectOrInput:"请选择或填写所导入包名",
            helpTitle:"使用说明",
            help1:"  Stage Now 配置方案是将设备常用参数汇聚一起，一站式设置后无需网络流量通过扫码、文件等形式导出复制到其他设备，快速部署，灵活便捷 。设备上需安装Stage Now客户端--移动设备管家(本身支持直接配置相关参数、APK,支持通过扫码、Wi-Fi局域网、文件导出),结合WEB网页端配置相关参数生成二维码,使用移动设备管家快速扫码导入。",
            help2:"1.按需选择参数进行配置，未配置参数将不会生成配置二维码；编辑完配置信息之后，可保存为配置方案，以便下次再使用；",
            help3:"2.因配置参数过多导出的二维码可能过于密集及模糊不易识别，可选择配置项分别导出；因机型配置差异，复制到不同机型的相关参数可能存在差异或无效情况;",
            help4:"3.因机型配置差异，复制到不同机型的相关参数可能存在差异或无效情况，根据需要配置参数可能进行变更。",
            close:"关闭",
            featureMsg:"复制导出本页配置项到设备中,只会生效对应设备里“特色设置APP”里已有的参数",
            CustomSource:"请选择或自定义源字符",
            desktopMsg:"自定义桌面类型只能添加一个",
            multiMag:"请选择或自定义分隔符",
            numBig0:"请输入不小于0的数字",
            inputSingleChar:"请输入单个字符",
            inputEndPosition:"请输入结束位置",
            InputStartPosition:"请输入开始位置",
            inputStartChar:"请输入开始字符",
            inputEndChar:"请输入结束字符",
            sGreaterEposition:"开始位置不能大于结束位置",
            eLessSposition:"结束位置不能小于开始位置",
            inputPackageName:"请输入包名",
            inputClassName:"请输入类名",
            inputName:"请输入名称",
            inputAction:"请输入Action",
            inputParameter:"请输入参数",
            inputKeyName:"请输入键值名称",
            selectType:"请选择类型",
            inputVirtualKey:"请输入虚拟键",
            complateEdit:"请完成编辑",
            selectBroadcast:"请选择广播",
            inputAppPackageName:"请输入应用包名",
            inputAppClassName:"请输入应用类名",
            mobileButlerTips:"此页面功能需移动管家APP版本大于V2.0.16",
            shortCutKeyTips:"此页面功能需热键设置APP版本大于V2.2.46",
            keyMappingTips:"配置成功后，需要重启设备才能生效！",
            screenSaverTips: '移动管家中用户名，密码，问题，答案，答案类型必须同时填写',
        },
        // 个性化配置
        setInfo:{
            StaticIPConfiguration:"静态IP配置",
            SingleAddition:"单个添加",
            BatchImport:"批量导入",
            snId:"设备号",
            ipAddress:"IP地址",
            mask:"子网掩码",
            gateway:"网关",
            wifiPwd:"Wi-Fi 密码",
            appIpAddress:"远程APP IP地址",
            operate:"操作",
            update:"编辑",
            delete:"删除",
            showPreview:"预览导出",
            noteInfo:{
                sn:"请填写设备S/N",
                ip:"请填写IP地址",
                mask:"请填写子网掩码",
                gateway:"请填写网关",
                dns1:"请填写设备DNS1",
                dns2:"请填写设备DNS2",
                ssid:"请填写Wi-Fi SSID",
                pwd:"请填写Wi-Fi密码",
                app:"请填写远程APP IP地址"
            },
            cancel:"取 消",
            save:"保 存",
            close:"关 闭",
            export:"导 出",
            static: "填写静态IP信息",
            temlpate: "请下载模板并严格按模板中的示例格式填写，表格中设备数量不超过100",
            info: '上传填好的信息表',
            model: "将填好的表格进行上传，若表格未按照要求填写则可能上传失败，需重新上传",
            UploadFiles: "上传文件",
            DownloadTemplate:"下载模板",
            first:"请先填写/导入IP配置",
            delIp:"确定删除当前IP配置?",
            prompt:"提 示",
            ok:"确 定",
            Successfully:'删除成功!',
            CancelledDeletion:"已取消删除",
            FileCompressionFailed:"文件压缩失败",
            FormatError:"文件格式错误，请删除后重新上传!",
            pleseUploadFile:"请上传文件!",
            CurrentMandatory:"当前选项必填",
            EnterValue:"请输入有效的值",
            WiFiSwitchTips:"* 设置Wi-Fi相关参数，需开启Wi-Fi开关，否则可能导致异常！"

        },
        // dataWedge
        dataWedge:{
            ASSOCIATED_PHYSICAL_RDBTitle:'关联实体按键扫描',
            ASSOCIATED_PHYSICAL_RDB:'关联实体按键',
            VOLUP:"vol+",
            VOLDOWN:'vol-',
            VOLNOTHING:'不关联',
            NewConfigurationAdd:"新增配置",
            NewProfile:"新建配置文件",
            ProfileName:"配置文件名称：",
            ConfigurationFileDescription:"配置文件描述：",
            EnterFileName:"请输入配置文件名称",
            EnterDescription:"请输入配置描述",
            cancel:"取消",
            submit:"确定",
            add:"添加",
            deleteContinue:"此操作将永久删除该配置, 是否继续?",
            prompt:"提示",
            deleteSuccess:"删除成功!",
            cancelDelete:"已取消删除",
            Application:"应用程序",
            AssociateApps:"关联应用",
            AssociateAppsFile:"将应用关联到此配置文件：",
            EnableConfigurationFile:"启用配置文件：",
            FloatingButton:"悬浮按钮",
            ActivateFloatingButton:"激活悬浮按键：",
            DefauleButton:"默认按钮显示模式：",
            ButtonMode:"按钮模式",
            ButtonOnlyMode:"仅按钮模式",
            FullScreen:"全屏模式",
            InitialPositionOfButton:"按钮初始位置(%)：",
            TriggerScanWaitTime:"触发扫描等待时间：",
            BarCodeInput:"条码输入",
            SelectScanner:"选择扫描器：",
            ScanningHead:"扫描头",
            TriggerScanningMode:"触发扫描模式：",
            RaiseHandToStop:"单次扫描(抬手停止)",
            SingleScan:"单次扫描",
            LiftHandScan:"单次扫描(抬手扫描)",
            ScanWithTwoPress:"单次扫描(两次按下扫描)",
            PressAgainToStop:"循环扫描(再次按下停止)",
            ContinuousLightEmission:"持续出光",
            CLRaiseHandToStop:"持续出光(抬手停止)",
            MultiBarcodeScanning:"多条码扫描",
            ReportWithRaiseHand:"多条码扫描(抬手上报)",
            ScanParameterConfiguration:"扫描参数配置",
            decoder:"解码器",
            MultipleBarcodeParameters:"多条码参数",
            EnableMultiBarcodeScan:"启用多条码扫描：",
            DisplayMultipleBarcodeCounts:"显示多条码计数：",
            NumberScanEachTime:"每次扫描的条码数",
            MultiReadTime:"多条码读取时长：",
            MultiBarcodeSplicing:"多条码拼接：",
            Disable:"不启用",
            Enable:"启用",
            NoDelimiter:"无分隔符",
            Space:"空格",
            lineBreak:"换行符",
            custom:"自定义",
            MultiBarcodeSpliceCustom:"多条码拼接自定义：",
            ReaderParameters:"读取器参数",
            CharacterSetConfiguration:"字符集配置：",
            QuasiCenterMode:"准心模式：",
            FillLightSwitch:"补光灯开关：",
            Exposure:"曝光：",
            LowQualityDecoding:"低质量解码工作：",
            WorkLevel1:"工作级别1",
            WorkLevel2:"工作级别2",
            WorkLevel3:"工作级别3",
            ScanParameters:"扫描参数",
            ScanSound:"扫描声音：",
            ScanVolumeType:"扫描音量类型：",
            UsingMediaVolume:"使用媒体音量",
            UsingCallVolume:"使用通话音量",
            UsingRingtonesAndCallVolume:"使用铃声和通知音量",
            UsingAlarmVolume:"使用闹钟音量",
            ScanningVibration:"扫描震动：",
            ScanningPromptLight:"扫描提示灯：",
            ScanTimeout:"扫描超时时间：",
            DPMMode:"DPM模式：",
            KeyOutput:"按键输出",
            EnableButtonOutput:"启用按键输出：",
            DataOutputMethod:"数据输出方式：",
            AnalogKey:"模拟按键",
            QuickFocus:"快速焦点",
            Clipboard:"剪贴板：",
            AutomaticallyClearData:"自动清空数据：",
            BasicDataFormatting:"基本数据格式化",
            PrefixData:"为数据加上前缀：",
            SuffixData:"为数据加上后缀：",
            ConvertInvisibleCharacters:"转换不可见字符：",
            SendInHexFormat:"十六进制形式发送：",
            AdvancedDataFormatting:"高级数据格式化",
            AddRules:"新增规则",
            EnableThisRule:"启用此规则：",
            StringToCheck:"要检查的字符串：",
            ApplicableBarcodeTypes:"适用条码类型：",
            DataDeletion:"数据删除",
            DeleteLeading0:"删除前导0",
            FilterInvisibleCharacters:"过滤不可见字符",
            DeleteSpecifiedCharacters:"删除指定字符",
            CharacterReplacement:"字符替换",
            OriginalCharacters:"原字符：",
            ReplaceCharacters:"替换字符：",
            BarcodeCapture:"条码截取",
            StartingInPositionalOrder:"按位置顺序开始：",
            LeftNumberPosition:"从左到右开始位置顺序数",
            EndInPositionalOrder:"按位置顺序结束：",
            LeftEndOrder:"从左到右结束位置顺序数",
            StartingWithSingleCharacter:"按单个字符设置：",
            StartSpecificCharacter:"开始于具体的单个字符",
            EndWithSingleCharacter:"按单个字符结束：",
            EndWithSpecificSingleCharacter:"结束于具体的单个字符",
            EndCharacter:"结束字符",
            IntentOutput:"Intent输出",
            EnableIntentOutput:"启用Intent输出：",
            BroadcastAction:"广播动作：",
            BroadcastDataLabel:"广播数据标签：",
            IPOutput:"IP输出",
            EnableIPOutput:"启用IP输出：",
            IPAddress:"IP地址：",
            Port:"端口：",
            NewRule:"新建规则",
            RuleName:"规则名称",
            EnterRuleName:"请输入规则名称",
            save:"保存",
            delete:"删除",
            set_spec_s_inter:"设置指定条码截取",
            set_spec_s_replace:"设置指定字符替换",
            set_spec_s_end:"设置指定结束字符",
            code_intercept:"条码截取",
            end_str:"结束字符",
            replace_string_title:"字符替换",
            success:"保存成功",
            set_spec_s_del:"设置指定删除字符串",
            data_delete:"数据删除",
            WhetherDelete:"是否删除该规则?",
            Tips:"提示",
            AlreadyRemoved:"已删除",
            DeleteCanceled:"已取消删除",
            subPackage:"说明：包名及子包名均需填写，子包名为活动页面，全部活动页面生效则在子包名后添加*号，部分生效则子包名（页面活动）之间使用英文逗号隔开。示例：包名填写com.android.chrome，全部活动页面生效子包名需填写com.android.chrome*，部分生效则按需填写多个子包名并使用逗号隔开。",
            AddedAppPackage:"新增应用程序包",
            PackageName:"包名",
            SubpackageName:"子包名",
            del_config_file:"默认通用参数配置文件",
            scandemo_pa_set:"Scan Demo参数设置",
            alre_ex_name:"已存在该名称配置!",
            RequiredRuleName:"规则名称不能为空",
            orderValues:"顺序值请不要重复",
            order:"顺序",
            Select:"请选择",
            AutoSubmit:'自动提交',
            BasicSettings:"基本设置",
            EnableLogging:"启用日志记录",
            administratorMode:"管理员模式",
            AdminPassword:"管理员密码",
            DeveloperMode:"开发者模式",
            dev_bc_start_scan:"开始扫描广播",
            dev_bc_stop_scan:"停止扫描广播",
            admin_pass:"管理员密码",
            confirmPass:"确认密码",
            set_admin_pass:"设置管理员密码",
            confirm_pass:"再次确认密码",
            EnterAdminPwd:"请输入管理员密码",
            hint_password_not_same:"*密码输入不一致!",
            data_wedge_set:"Data Wedge设置",
            scan_key_248_block:"屏蔽扫描键248",
            scan_key_249_block:"屏蔽扫描键249",
            scan_key_250_block:"屏蔽扫描键250",
            scan_key_block_title:"扫描键屏蔽",
            dataTips:"*此页面功扫码配置功能需Data wedge版本大于V1.1.3",
            isEndCharOnEmu:'结束符以按键方式发送',
            BarcodeFiltering:'条码过滤',
            '001':'按条码类型',
            '002':'输出条码',
            '003':"不输出条码",
            '004':"条码类型",
            '005':'按条码长度',
            '006':"条码长度",
            '007':'选择不输出条码则每次扫描按配置的规则不输出展示扫描的条码数据',
            '008':'请选择条码类型',
            '009':'请填写条码长度',
            numberOnlyWarning:"请输入数字类型",
        }
    },
    messageAdd:{
        mainPage:{
            versionMsg:"Stage Now 2.0移动客户端版本(移动设备管家)需大于5.0.0以上,低于此版本的请进入",
            oldVersion:"旧版本Stage Now",
            login:'登录',
            unlogin: '登出',
            '001':"配置设备参数",
            '002':'我的配置方案',
            '003':'配置常用参数',
            '004':"停用系统功能项",
            '005':"自定义配置模式",
            '006':'已保存的配置方案',
        },
        common:{
            '001':'Wi-Fi设置',
            '002':'移动网络设置',
            '003':'启动器设置',
            '004':'显示设置',
            '005':'声音设置',
            '006':'时间设置',
            '007':'USB设置',
            '008':'常用设置',
            '009':'特色设置',
            '010':'扫描设置',
            '011':'移动管家',
            '012':'热键设置',
        },
        wifi:{
            '001':'* 若开启此配置，新增Wi-Fi列表将失效',
            '002':'Wi-Fi黑白名单',
            '003':'黑白名单策略',
            '004':'无过滤器控制',
            '005':'SSID白名单',
            '006':'SSID黑名单',
            '007':'Wi-Fi信息已成功保存',
            '008':'表单验证失败，请检查填写内容',
            '009':'请先保存数据',
        },
        time:{
            '001':'时间设置',
            '002':'时间显示设置',
        },
        scanTool:{
            '001':'条码设置',
            '002':'应用设置',
            '003':'开始/结束位置不能为空',
            '004':'开始/结束字符不能为空'
        },
        mobile:{
            '001':'移动网络管理'
        },
        launcher:{
            '001':'启动器设置',
            '002':'自定义启动器',
            '003':'请先填写包名',
            '004':'请先保存数据',
            '005':'请先填写数据'
        },
        display:{
            '001':'显示设置',
            '002':'壁纸设置',
            '003':'管理壁纸',
            '004':'选择服务器',
            '005':'外部下载路径',
            '006':'外部链接',
            '007':'Stage Now服务器',
            '008':'上传文件',
            '009':'选择文件',
            '010':'上传服务器',
            '011':'文件格式错误，仅支持 .png、.jpg 格式!',
            '012':'文件大小不能超过10MB!',
            '013':'请先选择文件',
            '014':'请先将文件上传至服务器',
            '015':'只能上传一个文件',
            '016':'请先输入文件地址',
        },
        custom:{
            '001':"选择配置项",
            '002':'(请选择适量的配置项，选择过多生成的配置码数量将增多)',
            '003':'操作按钮',
            '004':'配置项',
            '005':'简介',
            '006':'选择',
            '007':'已选',
            '008':'清空',
            '009':'*长按可移动配置顺序',
            '010':'取消',
            '011':'确认',
            '012':'Wi-Fi设置',
            '013':'Wi-Fi相关参数设置',
            '014':'管理文件证书',
            '015':'管理及配置上传文件、Wi-Fi证书等',
            '016':'显示设置',
            '017':'屏幕亮度，字体大小，休眠时间等',
            '018':'移动网络设置',
            '019':'移动网络相关参数设置',
            '020':'常用设置',
            '021':'蓝牙开关、GPS开关、NFC开关、相机开关禁用通知等设置',
            '022':'启动器设置',
            '023':'默认桌面、壁纸、自定义桌面设置等',
            '024':'声音设置',
            '025':'设置铃声音量、媒体音量等',
            '026':'时间设置',
            '027':'设置时间格式、时区、确定网络时间等',
            '028':'USB设置',
            '029':'设置USB外部存储、ADB开关等',
            '030':'管理应用程序',
            '031':'应用下载及应用黑名单、保活、防卸载等应用管理',
            '032':'特色设置APP',
            '033':'调用特色设置APP,配置禁止状态栏下拉、隐藏软键盘、屏蔽虚拟按键、安装未知来源应用等',
            '034':'扫描工具APP',
            '035':'调用扫描工具APP,配置扫描相关参数',
            '036':'调用 Data Wedge APP(需安装),配置扫描参数、扫描方案等参数',
            '037':'该页面已添加！请勿重复添加',
            '038':'请至少添加一个页面！',
            '039':'已清空当前配置',
            '040':'自定义配置模式',
            '041':'暂未配置参数，请先配置',
            '042':'移动管家',
            '043':'调用移动管家 APP，配置自定义桌面及配置桌面可显示的应用，设置密码，开机自启动等',
            '044':'热键设置',
            '045':'调用热键设置APP（需安装），可快捷配置各实体键映射的对应功能',
        },
        deact:{
            '001':'停用系统功能项',
            '002':'*此页面可配置将常用的系统功能项停用、屏蔽或恢复。因以下操作对正常使用设备可能产生影响，生成的二维码在使用客户端扫码需输入密码，请谨慎操作！恢复出厂相关禁用屏蔽配置仍生效功能需移动端版本大于等于5.0.3.5。',
            '003':'通用设置',
            '004':'配置密码:',
            '005':'恢复使用全部功能项:',
            '006':'二维码有效期:',
            '007':'开始日期',
            '008':'结束日期',
            '009':'至',
            '010':'恢复出厂配置仍生效:',
            '011':'系统功能项',
            '012':'Wi-Fi功能:',
            '013':'SIM卡功能:',
            '014':'通话短信功能:',
            '015':'网络APN设置:',
            '016':'飞行模式:',
            '017':'短信功能:',
            '018':'蓝牙功能:',
            '019':'GPS定位功能:',
            '020':'相机功能:',
            '021':'NFC功能:',
            '022':'外置SD卡:',
            '023':'软键盘:',
            '024':'固定USB用途:',
            '025':'USB调试功能:',
            '026':'停用系统功能项',
            '027':'已重置当前页面参数',
            '028':'暂未配置参数，请先配置',
            '029':'数据发生错误',
            '030':'请填写配置密码',
            '031':'禁止使用',
            '032':'恢复使用',
            '033':'文件传输',
            '034':'USB网络共享',
            '035':'MIDI',
            '036':'PTP',
            '037':'不进行数据传输',
            '038':'飞行模式常开',
            '039':'关闭飞行模式常开',
            '040':'只能输入数字，‌大小写英文及字符,且最长15位',
            '041':'USB启禁用(连接PC)',
            '042':'开启飞行模式并锁定',
            '043':'关闭飞行模式并锁定',
            '044':'清除锁定并开启飞行模式',
            '045':'清除锁定并关闭飞行模式',
            '046':'若设备出厂预装过移动设备管家则此功能无效，定制版移动端请勿使用此功能。恢复出厂后需重启设备或打开“移动设备管家”才可生效。',
            '047':'开启并锁定',
            '048':'关闭并锁定',
            '049':'清除锁定并开启',
            '050':'清除锁定并关闭',
            '051':'WLAN热点',
        },
        manageApp:{
            '001':'APP下载',
            '002':'APP下载列表:',
            '003':'扫描下载有效期:',
            '004':'至',
            '005':'开始日期',
            '006':'结束日期',
            '007':'序号',
            '008':'获取服务器',
            '009':'外部下载路径',
            '010':'Stage Now服务器',
            '011':'下载路径',
            '012':'APP名称',
            '013':'版本',
            '014':'设备中存放路径',
            '015':'高低版本处理',
            '016':'保留高版本',
            '017':'强制覆盖安装',
            '018':'下载后动作',
            '019':'自动安装并启动',
            '020':'自动安装不启动',
            '021':'只下载不安装',
            '022':'启动方式',
            '023':'启动App',
            '024':'指定activity',
            '025':'指定service',
            '026':'启动类名',
            '027':'设置为启动器',
            '028':'是',
            '029':'否',
            '030':"操作",
            '031':'删除',
            '032':'编辑',
            '033':'APP卸载',
            '034':'卸载应用列表:',
            '035':'APP禁用',
            '036':'APP缓存清理',
            '037':'清理缓存应用列表:',
            '038':'卸载应用列表',
            '039':'禁用应用列表:',
            '040':'清理缓存应用列表:',
            '041':'下载路径',
            '042':'选择服务器',
            '043':'上传apk',
            '044':'选取文件',
            '045':'上传到服务器',
            '046':'App名称',
            '047':'版本',
            '048':'启动类名',
            '049':'设置为启动器',
            '050':'请选择类型',
            '051':'请输入下载路径',
            '052':'请输入应用名称',
            '053':'请填写版本',
            '054':'文件正在上传中请稍等',
            '055':'已成功上传至服务器',
            '056':'是否要将当前数据设置为启动项?',
            '057':'提示',
            '058':'确定',
            '059':'取消',
            '060':'请先将文件上传至服务器',
            '061':'是否删除当前配置信息?',
            '062':"删除成功!",
            '063':'已取消删除',
            '064':'选择服务器',
            '065':'说明:选择Stage Now服务器只支持APK格式,每次上传不超过10个,每个文件大小不超过200M。若需经常使用,可保存为方案以备后续使用,其中APK文件可保存6个月,到期后自动删除。',
            '066':'包名不能为空',
        },
        manageCert:{
            '001':'管理文件',
            '002':'文件下载',
            '003':'文件下载路径:',
            '004':'扫描下载有效期:',
            '005':'至',
            '006':'开始日期',
            '007':'结束日期',
            '008':'序号',
            '009':'获取服务器',
            '010':'外部下载路径',
            '011':'StageNow服务器',
            '012':'文件名称',
            '013':'文件类型',
            '014':'下载路径',
            '015':'设备中存放路径',
            '016':'操作',
            '017':'编辑',
            '018':'删除',
            '019':'文件删除',
            '020':'需删除文件路径:',
            '021':'管理证书',
            '022':'Wi-Fi证书下载',
            '023':'证书下载路径:',
            '024':'证书文件名称',
            '025':'下载成功后是否安装',
            '026':'是',
            '027':'否',
            '028':'安装密码',
            '029':'证书安装',
            '030':'需安装证书路径:',
            '031':'证书移除',
            '032':'需移除证书信息:',
            '033':'需删除的文件路径',
            '034':'文件在设备中的路径',
            '035':'需移除的证书文件名称',
            '036':'证书文件名称',
            '037':'需要安装的证书路径',
            '038':'证书在设备中的路径',
            '039':'文件下载路径',
            '040':'选择服务器',
            '041':'上传文件',
            '042':'选取文件',
            '043':'上传到服务器',
            '044':'证书下载路径',
            '045':'请选择类型',
            '046':'请输入下载路径',
            '047':'请输入文件名称',
            '048':'请输入文件类型',
            '049':'文件正在上传中请稍等',
            '050':'已成功上传至服务器',
            '051':'请先将文件上传至服务器',
            '052':'是否删除当前配置信息?',
            '053':'提示',
            '054':'确定',
            '055':'取消',
            '056':'删除成功!',
            '057':'已取消删除',
            '058':'路径不能为空',
            '059':'文件大小不能超过50MB!',
            '060':'最多上传10个文件',
            '061':'文件大小不能超过5MB!',
            '062':'最多上传30个文件',
            '063':'文件大小不能超过200MB!',
            '064':'证书文件名不能为空',

        },
        saveConfig:{
            '001':'方案列表',
            '002':'方案名称',
            '003':'方案类型',
            '004':'配置常用参数',
            '005':'停用系统功能项',
            '006':'自定义配置模式',
            '007':'创建时间',
            '008':'查看配置',
            '009':'配置码',
            '010':'删除',
            '011':'二维码预览',
            '012':'是否删除当前配置项?',
            '013':'提示',
            '014':'确定',
            '015':'取消',
            '016':'删除成功!',
            '017':'已取消删除',
            '018':'操作',
            '019':'此操作将覆盖当前参数配置, 是否继续?',
            '020':'* 若其他页面有正在配置中的参数，查看已保存配置方案将清空对应页面正在配置的参数'
        },
        app:{
            '001':'选择模式',
            '002':'循环扫描间隔',
            '003':'扫描无数据时的间隔时间',
            '004':'扫描有数据时的间隔时间',
        },
        general:{
            '001':'常用设置',
            '002':'系统快捷开关',
            '003':'蓝牙开关:',
            '004':'GPS开关:',
            '005':'NFC开关:',
            '006':'相机开关:',
            '007':'其它设置',
            '008':'系统语言设置:',
            '009':'消息通知设置:',
            '010':'中文',
            '011':'英文',
            '012':'虚拟导航栏',
            '013':'系统安全模式',
        },
        appSet:{
            '001':'数据已保存',
            '002':'请先配置参数',
            '003':'普通模式-循环扫描间隔数据必须存在且为数字',
            '004':'请检查当前填写的数据',
        },
        note: {
            '001':'已清空当前配置',
            '002':'暂未配置参数，请先配置',
            '003':'请登录',
            '004':'隐藏虚拟导航栏仅支持Android14系统',
            '005':'支持文件格式：.png 、.jpg，不超过10M。请根据机型制作并上传对应分辨率的图片。确定后将默认设置为默认桌面壁纸。',
        }
    },
    code: {
        'DA0200': '用户登录异常',
        'DA0230': '用户登录已过期',
        'DA0231': '用户未登录',
        'DA0301': '访问未授权',
        'DA0400': '用户请求参数错误',
        'DA0402': '无效的用户输入',
        'DA0410': '请求必填参数为空',
        'DA0420': '请求参数值超出允许的范围',
        'DA0421': '参数格式不匹配',
        'DA0501': '请求次数超出限制',
        'DA0700': '用户上传文件异常',
        'DA0701': '用户上传文件类型不匹配',
        'DA0702': '用户上传文件太大',
        'DA0706': '用户上传文件数量过多',
        'DA0707': '文件绑定失败',
        'DA0708': '用户上传文件总大小超出限制',
        'DA1100': '用户无查询数据权限',
        'DA1101': '无数据',
        'DA1200': '用户无删除数据权限',
        'DA1300': '用户无修改数据权限',
        'DB0001': '系统执行出错',
        'DB0324': '文件下载失败',
        'DC0001': '调用第三方服务出错',
        'DC0300': '数据库服务出错',
    },
    componentMsg:{
        '001':'语言',
        '002':'重置本页参数',
        '003':'保存为方案',
        '004':'预览二维码',
        '005':'导出二维码',
        '006':'导出配置文件',
        '007':'是否清空当前页面配置参数?',
        '008':'提示',
        '009':'确定',
        '010':'取消',
        '011':'已取消删除',
        '012':'保存为方案',
        '013':'方案名称',
        '014':'方案类型',
        '015':'配置常用参数',
        '016':'停用系统功能项',
        '017':'自定义配置模式',
        '018':'请输入方案名称',
        '019':'方案保存成功',
        '020':'二维码预览',
        '021':'预览配置文件',
    },
    ...zhLocale
}

export default cn;
